import { Fragment, useContext, useEffect, useState } from "react";
import { Dialog, Menu, Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import { DotsVerticalIcon } from "@heroicons/react/solid";
import axios from "axios";
import Collegueappel from "./Collegueappel";
import ScaleLoader from "react-spinners/ScaleLoader";
import { useTranslation, withTranslation } from "react-i18next";
import { Context } from "../../themeContext";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const token = localStorage.getItem("AccessToken");
const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const BackendURL = window.BackendURLCmk;
var lien = window.location.href;
const var22 = lien.split("/");

function CollegueProfile({ show, close, collegue }) {
  const { t } = useTranslation("common");
  const [stateObject, dispatch] = useContext(Context);

  const [open, setOpen] = useState(false);
  const [loading, setloading] = useState("false");

  const [profile, setProfile] = useState([]);
  const onlinecolor = (etat, com) => {
    if (etat === "Connecté") {
      if (com === "") {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 text-green-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21 3l-6 6m0 0V4m0 5h5M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
            />
          </svg>
        );
      } else if (com === "En com") {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 text-green-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21 3l-6 6m0 0V4m0 5h5M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
            />
          </svg>
        );
      }
    } else {
      if (com === "") {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 text-green-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21 3l-6 6m0 0V4m0 5h5M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
            />
          </svg>
        );
      } else {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 text-green-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M21 3l-6 6m0 0V4m0 5h5M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
          />
        </svg>;
      }
    }
  };
  // useEffect(() => {
  //   if (props.show == true) {
  //     const fetchData = async () => {
  //       var lien = window.location.href;
  //       console.log(lien);
  //       const var2 = lien.split("/");
  //       //console.log("kien ici", var2[2]);
  //       var var4 = var2[2].split(":");
  //       // console.log("kien ici", var4[0]);
  //       const result = await axios
  //         .get(
  //         )
  //         .then((res) => {
  //           console.log(res.data);
  //           setProfile(res.data.log_appel);
  //         })
  //         .catch((err) => {
  //           console.log("AXIOS ERROR: ", err);
  //         });
  //     };

  //     fetchData();
  //   }
  // }, []);

  useEffect(() => {
    // console.log("this is props", props.show);
    // const fetchData = async (poste2) => {
    if (show == true) {
      setloading(true);

      var lien = window.location.href;
      // console.log(lien);
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      const result = axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/LogAppelAvecColleguesIPBXV3API?compte=${compte}&poste=${poste}&collegue=${collegue.poste}`,
          config
        )
        .then((res) => {
          //console.log(res.data);
          setloading(false);

          setProfile(res.data.log_appel);
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    } else {
    }
    //   fetchData();
    // };
  }, [show]);
  // if (loading == false) {
  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog
        as="div"
        static
        className="fixed inset-0 overflow-hidden "
        open={open}
        onClose={close}
      >
        <div className="absolute inset-0 overflow-hidden ">
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="absolute inset-0 bg-gray-500 bg-opacity-60 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-y-0 right-0 pl-10 max-w-full flex sm:pl-16 ">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-500 sm:duration-700"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-500 sm:duration-700"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <div className="w-screen max-w-md">
                <div className="h-full flex flex-col bg-white shadow-xl overflow-y-scroll dark:bg-gray-800 dark:text-white">
                  <div className="px-4 py-6 sm:px-6">
                    <div className="flex items-start justify-between">
                      <Dialog.Title className="text-lg font-medium text-gray-900 dark:text-white">
                        {t("profilcolleg")}
                      </Dialog.Title>
                      <div className="ml-3 h-7 flex items-center">
                        <button
                          className="dark:bg-gray-800 dark:text-white bg-white rounded-md text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500"
                          onClick={close}
                        >
                          <span className="sr-only">Close panel</span>
                          <XIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                      </div>
                    </div>
                  </div>
                  {/* Main */}
                  <div className="divide-y divide-gray-200">
                    <div className="pb-6">
                      {/* <div className="bg-gray-800 h-24 sm:h-20 lg:h-28" /> */}
                      <div />

                      <div className="-mt-12 flow-root px-4 sm:-mt-8 sm:flex sm:items-end sm:px-6 lg:mt-4">
                        <div>
                          <div class="flex items-center">
                            <div class="flex-shrink-0">
                              {collegue.photo_poste_interne ? (
                                <img
                                  class="h-24 w-24 rounded-full mr-3"
                                  src={`${collegue.lien_photo_poste_interne}`}
                                />
                              ) : (
                                <span className="rounded-full overflow-hidden bg-gray-500 flex-shrink-0 h-24 w-24 sm:h-40 sm:w-40 lg:w-48 lg:h-48">
                                  <svg
                                    className="h-16 w-16 rounded-full mr-3 text-gray-300 dark:text-gray-300"
                                    fill="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"></path>
                                  </svg>
                                </span>
                              )}
                            </div>
                            <div className="mt-6 sm:ml-6 sm:flex-1">
                              <div>
                                <div className="flex items-center">
                                  <h3 className="dark:text-white font-bold text-xl text-gray-900 sm:text-2xl">
                                    {collegue.nom}
                                  </h3>
                                  {}{" "}
                                  {onlinecolor(collegue.encom, collegue.etat)}
                                  {/* <span className="ml-2.5 bg-green-400 flex-shrink-0 inline-block h-2 w-2 rounded-full">
                                    <span className="sr-only">Online</span>
                                  </span> */}
                                </div>
                                <p className="text-sm text-gray-500 dark:text-gray-400">
                                  {t("extension")} : {collegue.poste}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="mt-5 sm:space-y-3 sm:space-x-3">
                            <button
                              type="button"
                              onClick={() =>
                                dispatch({
                                  type: "MAKE_CALL",
                                  payload: {
                                    type: "CALL",
                                    number: collegue.poste,
                                    nom: collegue.nom,
                                    image: collegue.lien_photo_poste_interne,
                                  },
                                })
                              }
                              className="dark:bg-green-600  w-48  items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-800 hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:flex-1"
                            >
                              {t("Appeler")}
                            </button>
                          </div>
                          <div className="mt-5 flex flex-wrap space-y-3 sm:space-y-0 sm:space-x-3">
                            {/* <button
                              type="button"
                              className="flex-1 w-full inline-flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                              Message
                            </button> */}
                            {/* <span className="ml-3 inline-flex sm:ml-0">
                              <Menu
                                as="div"
                                className="relative inline-block text-left"
                              >
                                {({ open }) => (
                                  <>
                                    <Menu.Button className="inline-flex items-center p-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-400 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                      <span className="sr-only">
                                        Open options menu
                                      </span>
                                      <DotsVerticalIcon
                                        className="h-5 w-5"
                                        aria-hidden="true"
                                      />
                                    </Menu.Button>
                                    <Transition
                                      show={open}
                                      as={Fragment}
                                      enter="transition ease-out duration-100"
                                      enterFrom="transform opacity-0 scale-95"
                                      enterTo="transform opacity-100 scale-100"
                                      leave="transition ease-in duration-75"
                                      leaveFrom="transform opacity-100 scale-100"
                                      leaveTo="transform opacity-0 scale-95"
                                    >
                                      <Menu.Items
                                        static
                                        className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                                      >
                                        <div className="py-1">
                                          <Menu.Item></Menu.Item>
                                          <Menu.Item>
                                            {({ active }) => (
                                              <a
                                                href="#"
                                                className={classNames(
                                                  active
                                                    ? "bg-gray-100 text-gray-900"
                                                    : "text-gray-700",
                                                  "block px-4 py-2 text-sm"
                                                )}
                                              >
                                                View profile
                                              </a>
                                            )}
                                          </Menu.Item>
                                          <Menu.Item>
                                            {({ active }) => (
                                              <a
                                                href="#"
                                                className={classNames(
                                                  active
                                                    ? "bg-gray-100 text-gray-900"
                                                    : "text-gray-700",
                                                  "block px-4 py-2 text-sm"
                                                )}
                                              >
                                                Copy profile link
                                              </a>
                                            )}
                                          </Menu.Item>
                                        </div>
                                      </Menu.Items>
                                    </Transition>
                                  </>
                                )}
                              </Menu>
                            </span> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="px-4 py-5 sm:px-0 sm:py-0">
                      <dl className="space-y-8 sm:divide-y dark:divide-gray-600 sm:divide-gray-200 sm:space-y-0">
                        <div className="sm:flex sm:px-6 sm:py-5">
                          <dt className="dark:text-white text-sm font-medium text-gray-500 sm:w-40 sm:flex-shrink-0 lg:w-48">
                            {" "}
                            {t("departement")}
                          </dt>
                          <dd className="dark:text-gray-200 mt-1 text-sm text-gray-900 sm:mt-0 sm:ml-6 sm:col-span-2">
                            <p>{collegue.departement}</p>
                          </dd>
                        </div>
                        <div className="sm:flex sm:px-6 sm:py-5">
                          <dt className="dark:text-white text-sm font-medium text-gray-500 sm:flex-shrink-0 lg:w-48">
                            E-Mail
                          </dt>
                          <dd className="dark:text-gray-200 mt-1 text-sm text-gray-900 sm:mt-0 sm:ml-6 sm:col-span-2">
                            {collegue.adresse_mail}
                          </dd>
                        </div>
                        <div className="sm:flex sm:px-6 sm:py-5">
                          <dt className="dark:text-white text-sm font-medium text-gray-500 sm:w-40 sm:flex-shrink-0 lg:w-48">
                            {t("Adresse")}
                          </dt>
                          <dd className="dark:text-gray-200 mt-1 text-sm text-gray-900 sm:mt-0 sm:ml-6 sm:col-span-2">
                            <time dateTime="1982-06-23">
                              {collegue.adresse}
                            </time>
                          </dd>
                        </div>
                        <div className="sm:flex sm:px-6 sm:py-2">
                          <dt className="dark:text-white mt-2 text-sm font-medium text-gray-500 sm:w-40 sm:flex-shrink-0 lg:w-48">
                            {t("extension")}
                          </dt>
                          <dd className="text-sm text-gray-900 sm:mt-0 sm:ml-6 sm:col-span-2">
                            {collegue.poste ? (
                              <div className="cursor-pointer flex py-3 px-6 hover:border hover:border-gray-300 rounded-md  text-sm font-medium text-gray-500 dark:hover:bg-gray-700 dark:text-gray-200 hover:bg-gray-300 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-green-500 sm:flex-auto">
                                {" "}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="h-4 w-4 mt-0.5 mr-2 text-green-500"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                                  />
                                </svg>
                                <button
                                  type="button"
                                  className=" block text-sm text-gray-500 dark:text-gray-200"
                                  onClick={() =>
                                    dispatch({
                                      type: "MAKE_CALL",
                                      payload: {
                                        type: "CALL",
                                        number: collegue.poste,
                                        nom: collegue.nom,
                                        image:
                                          collegue.lien_photo_poste_interne,
                                      },
                                    })
                                  }
                                >
                                  {collegue.poste}
                                </button>
                              </div>
                            ) : (
                              <div></div>
                            )}
                          </dd>
                        </div>
                        <div className="sm:flex sm:px-6 sm:py-2">
                          <dt className="dark:text-white mt-2 text-sm font-medium text-gray-500 sm:w-40 sm:flex-shrink-0 lg:w-48">
                            Mobile{" "}
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:ml-6 sm:col-span-2">
                            {collegue.tel_mobil ? (
                              <div className="cursor-pointer flex py-3 px-6 hover:border hover:border-gray-300 rounded-md  text-sm font-medium text-gray-500 dark:hover:bg-gray-700 dark:text-gray-200 hover:bg-gray-300 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-green-500 sm:flex-auto">
                                {/* <div className="w-40 cursor-pointer flex py-3 px-6 items-center justify-center border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-500 bg-white hover:bg-gray-300 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-green-500 sm:flex-auto"> */}{" "}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="h-4 w-4 mt-0.5 mr-2 text-green-500"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                                  />
                                </svg>
                                <button
                                  type="button"
                                  className=" block text-sm text-gray-500 dark:text-gray-200"
                                  onClick={() =>
                                    dispatch({
                                      type: "MAKE_CALL",
                                      payload: {
                                        type: "CALL",
                                        number: collegue.tel_mobil,
                                        nom: collegue.nom,
                                        image:
                                          collegue.lien_photo_poste_interne,
                                      },
                                    })
                                  }
                                >
                                  {collegue.tel_mobil}
                                </button>
                              </div>
                            ) : (
                              <div></div>
                            )}
                          </dd>
                        </div>
                      </dl>
                    </div>
                    {loading == true ? (
                      <div className="flex justify-center  pt-44">
                        <ScaleLoader
                          color="#109669"
                          loading={loading}
                          size={50}
                          width={4}
                          height={68}
                        />
                      </div>
                    ) : (
                      <div>
                        {profile.length !== 0 ? (
                          <div className="flex flex-col">
                            <div className="">
                              <div className="dark:text-white text font-bold text-gray-900 px-1 py-4 ml-2">
                                {t("journalappel")}
                                <span className="dark:text-green-500 text-green-800">
                                  {" "}
                                  {collegue.nom}
                                </span>
                              </div>
                              <div className="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
                                <table className="min-w-full">
                                  <thead>
                                    {/* <tr className="flex text-center">
                                  {" "}
                                 
                                </tr> */}
                                    <tr>
                                      <th className="dark:bg-gray-600 dark:text-white  w-1/6 px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-2 font-medium text-gray-500 uppercase tracking-wider">
                                        &nbsp;
                                      </th>
                                      <th className="dark:bg-gray-600 dark:text-white  px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                        {t("calldate")}{" "}
                                      </th>
                                      <th className="dark:bg-gray-600 dark:text-white  px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                        {t("callduree")}{" "}
                                      </th>

                                      <th className="dark:bg-gray-600 dark:text-white  px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                        Actions
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="bg-white">
                                    {profile.map((post) => (
                                      <Collegueappel appel={post} />
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="flex flex-col">
                            <div className="">
                              <div className="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
                                <table className="min-w-full">
                                  <thead>
                                    <tr className="flex text-center">
                                      {" "}
                                      <div className="dark:text-white text-md font-bold text-gray-900 px-6 py-6">
                                        {t("nocallhistory")}
                                      </div>
                                    </tr>
                                  </thead>
                                </table>
                              </div>
                            </div>
                            <div className="flex justify-center  pt-28">
                              <div className="dark:text-white text font-bold text-gray-900 px-1 py-4 ml-2">
                                {t("woulduliketocall")}
                                <span className="text-green-800 dark:text-green-500">
                                  {" "}
                                  {collegue.nom} ?
                                </span>
                              </div>
                            </div>

                            <div className="dark:bg-gray-600 w-32 ml-40 cursor-pointer flex py-3 px-6 items-center justify-center border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-500 bg-white hover:bg-gray-300 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-green-500 sm:flex-auto">
                              {" "}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-4 w-4 mt-0.5 mr-2 text-green-800 dark:text-green-500"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                                />
                              </svg>
                              <button
                                type="button"
                                className=" block text-sm text-gray-800 dark:text-white"
                                onClick={() =>
                                  dispatch({
                                    type: "MAKE_CALL",
                                    payload: {
                                      type: "CALL",
                                      number: collegue.poste,
                                      nom: collegue.nom,
                                      image: collegue.lien_photo_poste_interne,
                                    },
                                  })
                                }
                              >
                                {t("Appeler")}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
export default withTranslation("common")(CollegueProfile);
